import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DDevolucionesServicios } from '@dian-api/devoluciones';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DContextoUsuarioServicio } from '@dian/api-identidad';
import { DContextoMuisca } from '@dian/core';
import { GeneralDialogComponent } from '../dialogos/general/general-dialog.component';
import { DialogsConfig } from '../../configuracion/dialog-views-data';

export interface DataDialogDevoluciones {
  
  personaRUT: any;
  modelo: any;
  contextoEstadoRUT: any;
  booFraccion: any;
  esExtemporaneo: any;
  tipoDocumento: any;
  
}

@Component({
  selector: 'app-devoluciones',
  templateUrl: './devoluciones.component.html',
  styleUrls: ['./devoluciones.component.css'],
  providers: [
    DNotificacionServicio,
    DContextoUsuarioServicio,
    DDevolucionesServicios
  ]
})
export class DevolucionesComponent implements OnInit {

  safeUrlVisor: SafeResourceUrl = '';
  data: DataDialogDevoluciones;

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<DevolucionesComponent>,
    //@Inject(MAT_DIALOG_DATA) public data: DataDialogDevoluciones,
    private sanitizer: DomSanitizer,
    private dNotificacionServicio: DNotificacionServicio,
    private dContextoUsuario: DContextoUsuarioServicio,
    private dDevoluciones: DDevolucionesServicios
  ) { }

  ngOnInit() {
    window.addEventListener('message', this.receiveMessage.bind(this), false);
    this.getDataAzure();
  }

  private getDataAzure() {    
    this.dContextoUsuario.consultarContextoUsuarioMuisca().subscribe(
      (res: DContextoMuisca) => {
        const contexto = <DContextoMuisca>JSON.parse(sessionStorage.getItem('DIAN-MUISCATK'));
        if (!contexto) {
          this.dNotificacionServicio.mostrarDialogoError("Error obteniendo el contexto para las devoluciones desde nube");
          return;
        }

//const preloader = this.dNotificacionServicio.mostrarDialogoCarga();
        const dataService = this.data;
        this.dDevoluciones.initialize(contexto.token.idToken, contexto.token.clientId);
        this.dDevoluciones.validacionCandidato(
          dataService.personaRUT,
          dataService.modelo,
          dataService.contextoEstadoRUT,
          dataService.booFraccion,
          dataService.esExtemporaneo,
          dataService.tipoDocumento

        ).subscribe(
          res => {
          //  preloader.close();
            if (!res) return;
            if (res.href)
            { 
              this.loadIframeVisor(res.href+'/'+contexto.token.idToken);
            }
            else {
              this.dialogRef.close();
              this.showPresentado();
            }
          
          },
          error => {
            console.error(error);
          //  preloader.close();
          }
        );
      }
    );
  }

  private receiveMessage(event: MessageEvent) {
    console.log("Evento desde componente hijo devoluciones: ",event);
    const allowOrigins = [
      'https://apipruebasazure.dian.gov.co', 
      'https://apiazure.dian.gov.co', 
      'https://webazure.dian.gov.co'
    ];
    if (!allowOrigins.includes(event.origin)) return;
    if (event.data.event === 'devoluciones')
      this.dialogRef.close(event.data.message);
  }

  // private sendMessageToIframe() {
  //   const iframe = document.getElementById('childIframe') as HTMLIFrameElement;
  //   if (iframe && iframe.contentWindow) {
  //     iframe.contentWindow.postMessage('Hello from parent', '*');
  //   }
  // }

  private loadIframeVisor(url: string) {
   
    this.safeUrlVisor = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  private showPresentado() {
    this.dialog.open(GeneralDialogComponent, {
      disableClose: true,
      data: DialogsConfig.dialogoPresentado
    });
  }

  closeModal() {
    this.dialogRef.close();
  }

}




// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/devoluciones/devoluciones.component.ts